import { get, toString } from 'lodash'

/**
 * Resolve Drupal JS setting.
 * @param {string} configKey
 * @return {string}
 */
export const getDrupalSetting = (configKey) => {
  const value = get(window || {}, `drupalSettings.react.${configKey}`, null)

  return toString(value)
}
